import { render } from "./HoverInfo.vue?vue&type=template&id=645c7a22&scoped=true"
import script from "./HoverInfo.vue?vue&type=script&lang=js"
export * from "./HoverInfo.vue?vue&type=script&lang=js"

import "./HoverInfo.vue?vue&type=style&index=0&id=645c7a22&scoped=true&lang=css"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645c7a22"]])

export default __exports__